import { IState } from 'src/core/store/state'

export const selectAppState = (state: IState) => state.app
